<template>
    <div>
        <div v-if="activeSubUsers || activeExtraNumbers">
            <div class="row head">
                <div class="col col-100">Huidige bundel(s)</div>
            </div>

            <div v-for="subUser in activeSubUsers" :key="subUser.id" class="row setting bundle subscription has-subitem">
              <router-link :to="{ name: 'account/bundles-request/extra-user-overview', params: { poc: $root.user.poc, bundleSubuserId: subUser.bundle_subusers_id }}">
                <div class="avatar avatar--extra-user"></div>
                <div class="account-info sub">
                    <div class="table">
                        <div class="cell">
                            <div class="account-info__title">Extra gebruiker</div>
                            <div class="account-info__subtitle">
                                <p class="account-info__subtitle--large">{{ subUser.bundle_subusers_email.includes('@') ? subUser.bundle_subusers_email : 'VOIP toestel' }}</p>
                            </div>
                        </div>
                    </div>
                </div>
              </router-link>
            </div>
            <div v-for="extraNumber in filteredExtraNumbers" :key="extraNumber.id" class="row setting bundle subscription">
                <div v-if="extraNumber.number_extension_id == 132">
                    <div class="avatar avatar--extra-mobile-number"></div>
                    <div class="account-info sub">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Extra mobiel nummer</div>
                                <div class="account-info__subtitle">
                                    <p class="account-info__subtitle--large">{{ extraNumber.phone_number_display }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="extraNumber.number_extension_id == 145">
                    <div class="avatar avatar--extra-business-number"></div>
                    <div class="account-info sub">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Extra bedrijfsnummer</div>
                                <div class="account-info__subtitle">
                                    <p class="account-info__subtitle--large">{{ extraNumber.phone_number_display }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="avatar avatar--extra-local-number"></div>
                    <div class="account-info sub">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Extra Nummer</div>
                                <div class="account-info__subtitle">
                                    <p class="account-info__subtitle--large">{{ extraNumber.phone_number_display }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row head">
            <div class="col col-100">Beschikbare bundels</div>
        </div>

        <div class="bundle-requests">
            <router-link  v-if="activeSubUsers == false || activeSubUsers.length < 4" :to="{ name: 'account/bundles-request/extra-user', params: { poc: $root.user.poc }}">
                <div class="row has-subitem setting subscription">
                    <div class="avatar avatar--extra-user"></div>
                    <div class="account-info sub">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Extra gebruiker</div>
                                <div class="account-info__subtitle">
                                    <p>Een collega, familielid, vriend of toestel toevoegen aan je account</p>
                                    <p class="account-info__subtitle--large">€1,00 exclusief btw p/m</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </router-link>

            <router-link v-if="activeExtraNumbers.length < 5" :to="{ name: 'account/bundles-request/extra-number', params: { poc: $root.user.poc, numberType: 'local' }}">
                <div class="row has-subitem setting subscription">
                    <div class="avatar avatar--extra-local-number"></div>
                    <div class="account-info sub">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Extra lokaal nummer</div>
                                <div class="account-info__subtitle">
                                    <p>Voeg een regionaal nummer toe aan je account. Dit werkt op basis van postcode</p>
                                    <p class="account-info__subtitle--large">€1,00 exclusief btw p/m</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </router-link>

            <router-link v-if="activeExtraNumbers.length < 5" :to="{ name: 'account/bundles-request/extra-number', params: { poc: $root.user.poc, numberType: 'business' }}">
                <div class="row has-subitem setting subscription">
                    <div class="avatar avatar--extra-business-number"></div>
                    <div class="account-info sub">
                        <div class="table">
                            <div class="cell">
                                <div class="account-info__title">Extra bedrijfsnummer</div>
                                <div class="account-info__subtitle">
                                    <p>Voeg een 085 nummer toe aan je account. Dit is een landelijk nummer tegen lokaal tarief</p>
                                    <p class="account-info__subtitle--large">€1,00 exclusief btw p/m</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </router-link>
        </div>
    </div>

</template>

<script>
    import { required, minLength, email } from 'vuelidate/lib/validators'
    export default {
        data() {
            return {
               bundles: [],
               activeSubUsers: [],
               activeExtraNumbers: [],
            }
        },

        validations: {
            extraEmail: {
                required,
                minLength: minLength(4),
                email
            },
            extraPassword: {
                required,
                minLength: minLength(4),
            },
            extraPostcode: {
                required,
            },
            extraHousenumber: {
                required,
            }
        },

        methods: {
            getBundles(){

                this.$api.get('/accounts/'+this.$root.user.poc+'/bundles')
                .then(response => {

                    this.bundles = response.data.bundles;
                })
                .catch(e => {

                });
            },

            getActiveBundles(){
                this.$api.get('/accounts/'+this.$root.user.poc+'/bundles/active')
                .then(response => {
                    this.activeSubUsers = response.data.subusers;
                    this.activeExtraNumbers = response.data.extranumbers;
                })
                .catch(e => {
                    console.log(e)
                })
            }
        },

        computed: {
            // if slot is 0, it's not an extra number but the head number
            filteredExtraNumbers: function() {
                return this.activeExtraNumbers.filter(activeExtraNumber => activeExtraNumber.bundle_extra_number_slot != 0)
            }
        },

        mounted() {
            this.getBundles();
            this.getActiveBundles();
        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/BundlesOverview.vue